// extracted by mini-css-extract-plugin
module.exports = {"invitationsContainer":"ApprovalRequest_invitationsContainer__2_Ale","invitationList":"ApprovalRequest_invitationList__2VyLq"};